export default __webpack_public_path__ + "static/icons.dark-9dffd8c36083453311ddaa99bd9f7e45.png";